// extracted by mini-css-extract-plugin
module.exports = {"icon":"BaseIcon_icon__g_2B8"};